import DataLoader from 'dataloader';
import fetch from 'cross-fetch';

import { isServer, getEnvironment } from '../utils';

const { BIND_ADDRESS = 'localhost', PORT = '3000' } = getEnvironment();
const BASE_URL = isServer
  ? `http://${BIND_ADDRESS}:${PORT}`
  : window.location.origin;

export const createEntryLoader = () =>
  new DataLoader(async (ids) => {
    const response = await fetch(`${BASE_URL}/content/pages?ids=${ids.join()}`);
    return response.json();
  });

export const entryLoader = createEntryLoader();
